import { Link } from "react-router-dom";
import { docSummary, driverName, findDriver, initials } from "../../lib/company";
import { useCompany } from "../../lib/companyContext";
import { cn, shortDate } from "../../lib/format";
import { PageTitle } from "../../components/company/ui";
import { useT } from "../../i18n";

/** Every driver who has sent this company a request. */
export default function CompanyCustomers() {
  const t = useT();
  const c = t.company.customers;
  const { state } = useCompany();

  const byDriver = new Map<string, typeof state.bookings>();
  for (const b of [...state.bookings].sort((a, z) => z.createdAt.localeCompare(a.createdAt))) {
    byDriver.set(b.driverId, [...(byDriver.get(b.driverId) ?? []), b]);
  }

  return (
    <>
      <PageTitle>{c.title}</PageTitle>
      <div className="grid gap-2.5">
        {[...byDriver].map(([driverId, bookings]) => {
          const driver = findDriver(state, driverId);
          const latest = bookings[0];
          const docs = docSummary(driver);
          const accepted = bookings.some((b) => ["confirmed", "active", "completed"].includes(b.status));
          return (
            <div key={driverId} className="flex flex-wrap items-center gap-3.5 rounded-card bg-white p-4">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-ink text-[13px] font-medium text-white">
                {initials(driver)}
              </div>
              <div className="min-w-45 flex-1">
                <div className="text-[15px] font-medium">{driverName(driver)}</div>
                <div className="text-[13px] text-muted">
                  {driver?.city} · {accepted ? driver?.phone : c.contactHidden}
                </div>
              </div>
              <div className="min-w-30 text-[13px]">
                {c.bookings(bookings.length)}
                <div className="text-xs text-muted">
                  {t.company.status.booking[latest.status]} · {shortDate(latest.start)}
                </div>
              </div>
              <span className={cn("min-w-30 text-xs", docs.className)}>{docs.text}</span>
              <Link to={`/company/bookings/${latest.id}`} className="text-[13px] text-brand hover:text-brand-link">
                {c.latest}
              </Link>
            </div>
          );
        })}
        {byDriver.size === 0 && (
          <div className="rounded-card bg-white px-6 py-12 text-center text-sm text-muted">
            {c.empty}
          </div>
        )}
      </div>
    </>
  );
}
